import * as R from "ramda";

export const findTeam = R.curry((id, teams) =>
  R.pipe(
    R.defaultTo([]),
    R.find(R.propEq("id", id))
  )(teams)
);

export const getTeam = state => {
  const teamId =
    R.path(["team", "id"])(state) ||
    R.path(["opportunity", "selected", "team"])(state);

  return findTeam(teamId, R.prop("teams", state)) || {};
};
